import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["customField", "error"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { absurd } from 'fp-ts/function';
import { AutocompleteFormField, DatePickerFormField, TextFormField } from '../../form';
import { CustomFieldFormDate, CustomFieldMultiSelect, CustomFieldPickList, CustomFieldText } from './codecs';
import { jsx as _jsx } from "react/jsx-runtime";

var CustomFields = function CustomFields(_ref) {
  var customField = _ref.customField,
      error = _ref.error,
      controllerProps = _objectWithoutProperties(_ref, _excluded);

  if (CustomFieldText.is(customField)) return /*#__PURE__*/_jsx(TextFormField, _objectSpread(_objectSpread({}, controllerProps), {}, {
    label: customField.name,
    error: error
  }));

  if (CustomFieldPickList.is(customField)) {
    return /*#__PURE__*/_jsx(AutocompleteFormField, _objectSpread(_objectSpread({}, controllerProps), {}, {
      label: customField.name,
      options: customField.valueOptions.map(function (o) {
        return {
          label: o,
          value: o
        };
      }),
      error: error
    }));
  }

  if (CustomFieldFormDate.is(customField)) {
    return /*#__PURE__*/_jsx(DatePickerFormField, _objectSpread(_objectSpread({}, controllerProps), {}, {
      label: customField.name,
      error: error
    }));
  }

  if (CustomFieldMultiSelect.is(customField)) {
    return /*#__PURE__*/_jsx(AutocompleteFormField, _objectSpread(_objectSpread({}, controllerProps), {}, {
      multiple: true,
      label: customField.name,
      options: customField.valueOptions.map(function (o) {
        return {
          label: o,
          value: o
        };
      }),
      error: error
    }));
  }

  return absurd(customField);
};

export default CustomFields;